import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-general-star-icon',
  templateUrl: './general-star.component.html'
})
export class GeneralStarComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
